if (!window.Eurus.loadedScript.has('pincode-checker.js')) {
  window.Eurus.loadedScript.add('pincode-checker.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xPincodeChecker', () => ({
        pincode: '',
        loading: false,
        status: '',
        message: '',
        api: {},
        gap: 2,
        locale: 'en-IN',
        text: {},

        init() {
          const data = this.$el.dataset;

          this.api = {
            endpoint: 'https://api.horocosmo.store/api/shipping/serviceability/',
            pickup: (data.pickup || '').trim(),
            weight: (data.weight || '1').trim(),
            cod: (data.cod || '1').trim(),
            token: (data.token || '').trim(),
          };

          this.gap = parseInt(data.gap, 10) || 2;
          this.locale = data.locale || 'en-IN';

          this.text = {
            button: data.buttonLabel || 'Check',
            loading: data.loadingLabel || 'Checking…',
            invalid: data.invalidText || 'Please enter a valid 6-digit pincode.',
            available: data.availableText || 'Delivery between (range)',
            unavailable: data.unavailableText || 'Sorry, delivery is not available to this pincode.',
            error: data.errorText || 'Unable to check delivery right now. Please try again.',
          };
        },

        onInput() {
          this.pincode = this.pincode.replace(/\D/g, '').slice(0, 6);
          if (this.status) {
            this.status = '';
            this.message = '';
          }
        },

        get isValid() {
          return /^\d{6}$/.test(this.pincode);
        },

        async check() {
          if (this.loading) return;

          if (!this.isValid) {
            this.setResult('error', this.text.invalid);
            return;
          }

          if (!this.api.token || !this.api.pickup) {
            this.setResult('error', this.text.error);
            return;
          }

          this.loading = true;
          this.status = '';
          this.message = '';

          try {
            const params = new URLSearchParams({
              delivery_postcode: this.pincode,
              pickup_postcode: this.api.pickup,
              weight: this.api.weight,
              cod: this.api.cod,
            });

            const response = await fetch(`${this.api.endpoint}?${params.toString()}`, {
              method: 'GET',
              headers: { Authorization: `Bearer ${this.api.token}` },
            });

            if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

            const result = await response.json();
            const couriers = result?.delivery_window;

            if (couriers) {
              this.setResult('success', this.text.available.replace('(range)', couriers));
            } else {
              this.setResult('unavailable', this.text.unavailable);
            }
          } catch (error) {
            console.error('[pincode-checker]', error);
            this.setResult('error', this.text.error);
          } finally {
            this.loading = false;
          }
        },

        setResult(status, message) {
          this.status = status;
          this.message = message;
        },

        resolveRange(couriers) {
          if (!Array.isArray(couriers) || !couriers.length) return '';

          const today = new Date();
          today.setHours(0, 0, 0, 0);

          let earliest = null;
          couriers.forEach((courier) => {
            const date = this.parseEtd(courier, today);
            if (date && (!earliest || date < earliest)) earliest = date;
          });

          if (!earliest) return '';

          const to = new Date(earliest);
          to.setDate(to.getDate() + this.gap);

          return `${this.formatDate(earliest)} - ${this.formatDate(to)}`;
        },

        parseEtd(courier, today) {
          if (courier && courier.etd) {
            const parsed = new Date(courier.etd);
            if (!isNaN(parsed.getTime())) {
              parsed.setHours(0, 0, 0, 0);
              return parsed;
            }
          }

          const days = parseInt(courier && courier.estimated_delivery_days, 10);
          if (!isNaN(days) && days > 0) {
            const date = new Date(today);
            date.setDate(date.getDate() + days);
            return date;
          }

          return null;
        },

        formatDate(date) {
          try {
            return new Intl.DateTimeFormat(this.locale, { day: '2-digit', month: 'short' }).format(date);
          } catch (error) {
            return date.toDateString();
          }
        },
      }));
    });
  });
}
